import React, { useMemo } from 'react';
import { TEXT_COLOR } from '../theme';
import { Link as RouterLink } from 'react-router';
import { useSelector } from 'react-redux';
import { Alert, Box, Button, CircularProgress, Link, Typography } from '@mui/material';
import useResetPasswordRequest from '../hooks/useResetPasswordRequest';
import { withLanguage } from './common/Texts';
import AuthShell from './auth/AuthShell';
import LabeledField from './auth/LabeledField';

export default function ResetPasswordRequest() {
    const { username, setUsername, email, setEmail, error, loading, submit } = useResetPasswordRequest();
    const language = useSelector((state) => state.user.language);
    const t = useMemo(() => withLanguage(language), [language]);

    const onSubmit = (e) => {
        e.preventDefault();
        if (!loading) submit();
    };

    return (
        <AuthShell onSubmit={onSubmit}>
            <Typography variant="body2" color="text.secondary" align="center">
                {t('request_password_reset_title')}
            </Typography>

            {error && <Alert severity="error" variant="outlined">{error}</Alert>}

            <LabeledField
                id="reset-username"
                name="username"
                label={t('user')}
                autoFocus autoComplete="username"
                value={username} onChange={(e) => setUsername(e.target.value)}
            />

            <LabeledField
                id="reset-email"
                name="email"
                type="email"
                label="Email"
                autoComplete="email"
                value={email} onChange={(e) => setEmail(e.target.value)}
            />

            <Button
                type="submit" fullWidth variant="contained" color="primary"
                disabled={loading}
                startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
            >
                {t('request_password_reset_button')}
            </Button>

            <Box sx={{ textAlign: 'center' }}>
                <Link
                    component={RouterLink} to="/login"
                    variant="body2" underline="hover" sx={{ color: TEXT_COLOR }}
                >
                    {t('back_to_login')}
                </Link>
            </Box>
        </AuthShell>
    );
}
